import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';
import { calculateWidth, vh } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(() => ({
  informationContainer: {
    borderBottom: `1px solid ${themeColor.borderGray}`,
    paddingLeft: '0.5vw',
  },
  posInformation: {
    width: '25.32vw',
    height: '2.6vh',
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(1.56),
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.67,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColor.infoMain,
  },
  loggedInUserContainer: {
    paddingTop: '3.25vh',
    paddingLeft: '1.31vw',
    paddingBottom: '4.55vh',
    borderBottom: `1px solid ${themeColor.borderGray}`,
  },
  userImage: {
    width: '8vh',
    height: '8vh',
    borderRadius: '50%',
    backgroundColor: themeColor.white,
    color: themeColor.secondaryContrast,
  },
  userInformationContainer: {
    paddingLeft: '0.8vw',
    '@media (min-width: 1366px) and (max-height: 1200px) and (min-height: 768px)': {
      paddingLeft: '0.8vw',
    },
    '& > div': {
      '&.userName': {
        width: '12.73vw',
        height: '3.38vh',
        fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
        fontSize: vh(2.6),
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 1,
        color: themeColor.defaultTextColor,
      },
      '&.unitNumber': {
        width: '4.24vw',
        height: '2.08vh',
        fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
        fontSize: vh(2.08),
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1,
        letterSpacing: 0.18,
        color: themeColor.infoDark,
      },
      '&.timeStamp': {
        width: '13.17vw',
        height: '2.99vh',
        fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
        fontSize: vh(2.08),
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.44,
        letterSpacing: 'normal',
        color: themeColor.infoMain,
      },
    },
  },
  configurationMenuContainer: {
    paddingTop: '3.51vh',
    paddingLeft: '1.9vw',
    paddingRight: '3.19vw',
    '& > div': {
      paddingBottom: '0.83vh',
    },
  },
  configurationMenuLabel: {
    fontSize: vh(2.34),
    color: themeColor.defaultTextColor,
    textAlign: 'left',
    textTransform: 'initial',
  },
  homeMenuIcon: {
    color: themeColor.infoDark,
    marginRight: 0,
    '& > *:first-child': {
      width: '1em',
      height: '0.7em',
      fontSize: vh(4.75),
    },
    '@media (max-height: 1080px)': {
      paddingRight: calculateWidth(55, 1920).stringValue,
    },
    '@media (max-height: 768px)': {
      paddingRight: '2.63vw',
    },
    '@media (max-width: 1024px) and (max-height: 768px)': {
      paddingRight: calculateWidth(32, 1024).stringValue,
    },
    '@media (max-height: 720px)': {
      paddingRight: calculateWidth(32, 1280).stringValue,
    },
    '@media (max-height: 576px)': {
      paddingRight: calculateWidth(28, 1024).stringValue,
    },
  },
  homeMenuDropdownIcon: {
    color: themeColor.infoDark,
    '& > *:first-child': {
      fontSize: vh(3.84),
    },
  },
  configurationMenuButton: {
    justifyContent: 'flex-start',
  },
  homeMenuDisabledItem: {
    opacity: 0.4,
  },
}));
